import React, { Component } from 'react';
import { Modal } from 'antd-mobile';
import { inject, observer } from 'mobx-react';
import Config from 'config/Config';
import './indexLess.less';
import shopHomeMod from '../../pages/Shop/Home/ShopHome/ShopHomeMod';
import AppMod from 'widget/App/AppMod';
import { toJS } from 'mobx';
import Util from 'utils';
import activeAdPopupMod from './indexMod';
import PromoteModal from 'pages/Shop/Product/ProductDetail/PromoteModal/AdPromoteModalView';
const CDN_BASE = Config.CDN_BASE || '';

// // @inject('ActiveAdPopupMod')
// @inject('ShopHomeMod')
// @withRouter
@observer
class ActiveAdPopup extends Component {
  constructor(props) {
    super(props);
    this.appStore = AppMod;
    this.state = {
      productInfo: {}
    };
  }
  async componentDidMount() {
    const { itemInfo } = this.props;
    const { popupRemindType, itemCode } = itemInfo || {};
    // 如果是产品分享提示 则调取产品详情 并弹出海报
    if (popupRemindType === 6 && itemCode) {
      const productInfo = await activeAdPopupMod.getProductDetail(itemCode);
      this.setState({
        productInfo
      });
      this.setState({ showPromoteModal: true });
    }
  }
  // 文字提示弹窗
  renderTextModal(item) {
    console.log('文字提示弹窗', item);
    const { popupRemindContent } = item;
    const { onClose } = this.props;
    return (
      <div>
        <div
          style={{
            fontSize: 28,
            textAlign: 'center',
            lineHeight: '40px',
            padding: '0 50px',
            marginBottom: 40,
            color: 'rgba(0, 0, 0, 0.8)'
          }}>
          {popupRemindContent}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <div
            style={{
              width: '60%',
              lineHeight: '80px',
              fontSize: 32,
              color: 'white',
              backgroundColor: 'black',
              textAlign: 'center'
            }}
            onClick={() => {
              if ((item.buryingPointType || '').includes('2')) {
                window.sensors.track('popupRecord', {
                  type: '2',
                  popup_id: item.id, // 弹窗id
                  isLogin: !!this.appStore.userInfo.token,
                  special_page_id: item.thematicId,
                  userId: this.appStore.userInfo.id || '',
                  channal: 'H5'
                });
              }
              onClose && onClose();
            }}>
            我知道了
          </div>
        </div>
      </div>
    );
  }
  // 图片提示弹窗
  renderPicModal(item) {
    console.log('图片提示弹窗', item);
    const { onClose, onJumpBack } = this.props;
    if (!item || !item.promptImgUrl) return null;
    let imgUrl = '';
    try {
      const imgJson = (item.promptImgUrl && JSON.parse(item.promptImgUrl)) || {};
      imgUrl = imgJson.imgUrl || '';
    } catch (error) {
      console.log('WindowCell - getImgUrl error', error);
      imgUrl = item.imgUrl || '';
    }
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <div
          style={{ width: '100%' }}
          onClick={() => {
            if (this.appStore.popupPosition == 9) {
              // if(!this.appStore.userInfo.token && item.id){
              //   this.appStore.changeState('dojumpData', item.id)
              // }
              window.sensors.track('homePopup', {
                popup_id: item.id, // 弹窗id
                isLogin: !!this.appStore.userInfo.token,
                userId: this.appStore.userInfo.id || ''
              });
            }
            if (!item.linkType || item.linkType == 0) {
              // 无链接
              return;
            }
            if ((item.buryingPointType || '').includes('2')) {
              window.sensors.track('popupRecord', {
                type: '2',
                popup_id: item.id, // 弹窗id
                isLogin: !!this.appStore.userInfo.token,
                special_page_id: item.thematicId,
                userId: this.appStore.userInfo.id || '',
                channal: 'H5'
              });
            }
            if (item && item.linkType) {
              item.type = Number(item.linkType);
            }
            if (item.mobileContractFlag) {
              window.app.routerGoTo({
                pathname: '/agreements/topicAgreement',
                state: {
                  id: item.content
                }
              });
            } else {
              let route = '';
              if (item.content == '1312034885970491519') {
                item.birthDayTag = 1;
              }
              if (item.linkType == 16) {
                // type 10 直播,16企微
                return;
              }
              shopHomeMod.doLinkJump({ ...item, isPopRecommend: true });
            }
            onJumpBack();
          }}>
          <img src={imgUrl} style={{ width: '100%', height: '100%' }} />
        </div>
        <img
          style={{ width: '65px', marginTop: '58px' }}
          src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
          onClick={() => {
            onClose && onClose();
          }}
        />
      </div>
    );
  }

  // 专题页分享弹窗
  renderShareModal() {
    const { onClose } = this.props;
    const { productInfo = {}, showPromoteModal } = this.state;
    if (!showPromoteModal || !this.appStore.token || !productInfo.id) return null;
    const posterList = productInfo.posterImgRespDtoList || [];
    const mediaRespDtoList = productInfo.mediaRespDtoList || [];
    const defaultList = Util.getProductImg(mediaRespDtoList);
    const hasPoster = posterList.length > 0;
    // console.log('defaultList', defaultList);
    // if (!posterList.length) return null;
    return (
      <PromoteModal
        userInfo={toJS(this.appStore.userInfo)}
        isLY={toJS(this.appStore.isLY)}
        productInfo={productInfo}
        posterList={hasPoster ? posterList : [{ imgUrl: defaultList }]}
        visible={showPromoteModal}
        showDefault={!hasPoster}
        onClose={() => {
          onClose && onClose(); // 关闭原来的弹窗
          this.setState({ showPromoteModal: false });
        }}
      />
    );
  }

  render() {
    const { itemInfo } = this.props;
    const { popupRemindType } = itemInfo || {}; //弹窗类型：popupRemindType  1.文字提示   2.图片提示   3.专题页提示  6: 产品分享提示
    console.log('00000000000000000000000000');

    return (
      <div className="popup-container">
        {popupRemindType === 2 && this.renderPicModal(itemInfo)}
        {popupRemindType === 1 && this.renderTextModal(itemInfo)}
        {popupRemindType === 6 && this.renderShareModal(itemInfo)}
      </div>
    );
  }
}
export default ActiveAdPopup;



// WEBPACK FOOTER //
// ./src/pubBiz/ActiveAdPopup/index.js